import * as yup from "yup";
import { UpgradeStaffMemberFormValues } from "./types";

export const defaultFormValues: UpgradeStaffMemberFormValues = {
  staffId: "",
  emailAddress: "",
  username: "",
  newPassword: "",
  confirmPassword: "",
};

export const schema = yup.object().shape({
  staffId: yup.string().required("Staff ID is required"),
  emailAddress: yup
    .string()
    .email("Invalid email")
    .required("Email is required"),
  username: yup.string().required("Username is required"),
  newPassword: yup
    .string()
    .min(6, "Password must be at least 6 characters")
    .optional(),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("newPassword"), null], "Passwords must match")
    .optional(),
});
